t = require('app/scripts/views/internal/teacup-with-helpers')('edit_attachment')

module.exports = t.renderable ({ serviceKey, url, name }) ->
  t.form ->
    if (serviceKey == 'other')
      t.label ->
        t.format 'attachment-url'
        t.input '.js-attachment-url', { type: 'text', value: url }

    t.label ->
      if (serviceKey == 'other')
        t.format 'attachment-name-optional'
      else
        t.format 'attachment-name'
      t.input '.js-attachment-name.js-autofocus', { type: 'text', value: name }

    t.input '.js-edit-attachment.wide.primary', { style: 'margin: 0;', type: 'submit', value: t.l 'update-attachment' }

    t.div '.hide.save-attachment-container'
